import { render, staticRenderFns } from "./AssetTypeChangeLogsDetailsView.vue?vue&type=template&id=63874aca&scoped=true"
import script from "./AssetTypeChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./AssetTypeChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./AssetTypeChangeLogsDetailsView.vue?vue&type=style&index=0&id=63874aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63874aca",
  null
  
)

export default component.exports